// extracted by mini-css-extract-plugin
export default {"download-button":"download-button_download-button__dYi-S","active":"download-button_active__ao80X","processing":"download-button_processing__HLpKg"};